import { journeyAction, } from './base';

import { JourneyActionJourney as JourneyActionJourneyBase, } from 'atlas-shared';

export const JourneyActionJourney = journeyAction({
  ...JourneyActionJourneyBase,
  icon: 'Journey',
});
